import { cn } from "@/utils/cn";
import { memo, useState } from "react";
import { RenderImageState } from "./render-image-state";

interface ImageLoadingProps {
  src: string;
  alt: string;
  classNames?: {
    container?: string;
    image?: string;
  };
  notFoundImage?: React.ReactNode;
  errorImage?: React.ReactNode;
}

const ImageWithLoading = memo(function ImageWithLoading({
  src,
  alt,
  classNames,
  notFoundImage,
  errorImage,
}: ImageLoadingProps) {
  const [status, setStatus] = useState<"loading" | "error" | "loaded">("loading");

  return (
    <div
      role="img"
      className={cn(
        "bg-image-loading relative flex h-64 w-64 items-center justify-center",
        classNames?.container,
      )}
    >
      <RenderImageState
        src={src}
        alt={alt}
        status={status}
        notFoundImage={notFoundImage}
        errorImage={errorImage}
        classNames={classNames}
        setStatus={setStatus}
      />
    </div>
  );
});

export default ImageWithLoading;
